import { Router } from '@angular/router';
import { AngularMigrationHelperService } from 'src/ajs-app/services/angularMigrationHelper.service';
import { environment } from 'src/environments/environment';

const bundledWithAngularJSApp = environment.bundledWithAngularJSApp;
const ajsProviderDependencies = bundledWithAngularJSApp ? ['$injector'] : [];

/**
 * This file groups the angularjs services that are updgraded (so that they can be used from the angular code)
 */

//
// MessagesFactory
//
export class AJSMessagesService {
  sites;
  showUserInteractions: (companyId, siteId, userId, avatarUrl, taskId, organizationId) => void;
}

export function ajsMessagesServiceFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('MessagesFactory') : new AJSMessagesService();
}

export const ajsMessagesServiceProvider = {
  provide: AJSMessagesService,
  useFactory: ajsMessagesServiceFactory,
  deps: ajsProviderDependencies,
};

//
// TaskFactory
//

// This class is used both for typing and as a dummy placeholder for when we aren't bundle with the ajs app
export class AJSTasksService {
  backToTasksList: (queueId?: string) => void;
  acquireCurrentTaskAndReloadState: () => void;
}

export function ajsTasksServiceFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('TasksFactory') : new AJSTasksService();
}

export const ajsTasksServiceProvider = {
  provide: AJSTasksService,
  useFactory: ajsTasksServiceFactory,
  deps: ajsProviderDependencies,
};

//
// TriageFactory
//

// This class is used both for typing and as a dummy placeholder for when we aren't bundle with the ajs app
export class AJSTriageService {
  goToTriageRule: (ruleId) => void;
}

export function ajsTriageServiceFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('TriageFactory') : new AJSTriageService();
}

export const ajsTriageServiceProvider = {
  provide: AJSTriageService,
  useFactory: ajsTriageServiceFactory,
  deps: ajsProviderDependencies,
};

//
// CatalogsFactory
//

// This class is used for routing to catalogs page which is ts component embedded in a js page.
export class AJSCatalogsService {
  goToCatalogs: () => void;
}

export function ajsCatalogsServiceFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('CatalogsFactory') : new AJSCatalogsService();
}

export const ajsCatalogsServiceProvider = {
  provide: AJSCatalogsService,
  useFactory: ajsCatalogsServiceFactory,
  deps: ajsProviderDependencies,
};

//
// AngularMigrationHelperService
//

export function ajsMigrationHelperServiceFactory(ajsInjector) {
  return bundledWithAngularJSApp
    ? ajsInjector.get('AngularMigrationHelperFactory')
    : new AngularMigrationHelperService(null);
}

export const ajsMigrationHelperServiceServiceProvider = {
  provide: AngularMigrationHelperService,
  useFactory: ajsMigrationHelperServiceFactory,
  deps: ajsProviderDependencies,
};

//
// Custom Router to prepare the migration.
//

export class CustomRouter {
  //AngularJS
  includes: (state: string) => boolean;
  go: (stateName, params?: any, options?: any) => void;
  reload: (stateName?: string, params?: any) => void;
  href: (stateName: string, stateParams: any) => string;
  transitionTo: (name: string, params: any, options?: any) => void;
  params: any;
  current: { name: string; data: any };

  // Angular
  navigateByUrl: (url: string) => Promise<boolean>;
}

export function CustomRouterFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('$state') : Router;
}

export const ajsCustomRouterProvider = {
  provide: CustomRouter,
  useFactory: CustomRouterFactory,
  deps: ajsProviderDependencies,
};

export class TopToolbarService {
  // AngularJS
  updateButtonDisable: (disable: boolean) => void;

  // Angular
}

export const ajsTopToolbarProvider = {
  provide: TopToolbarService,
  useFactory: TopToolbarFactory,
  deps: ajsProviderDependencies,
};

class TopToolbarServiceHelper {}

export function TopToolbarFactory(ajsInjector) {
  return bundledWithAngularJSApp ? ajsInjector.get('TopToolbarFactory') : TopToolbarServiceHelper;
}
